<template>
  <div
    :class="{ 
      'athena-header-search': mode == 'athena-header',
      'vogue-header-search': vogue_mode == 'popup' ,// vogue导航栏搜索弹窗模式
      }"
    v-show="active"
    @click.stop
  >
    <form
      class="search-input"
      action="/search"
      @submit="subSearch"
      v-if="vogue_mode == 'popup'"
    >
      <div class="form-group">
        <input
          class="form-control secondary_title"
          type="text"
          name="q"
          v-model="search_string"
          ref="input"
          :placeholder="$t('home.search_our_store')"
        />
        <button type="submit" class="nav-search-submit">
          <span class="iconfont icon-sousuo" style="font-size: 22px"></span>
        </button>
        <button type="submit" class="nav-search-submit nav-search-text">
          <span style="font-size: 14px">{{ $t("venue.home.search") }}</span>
        </button>
      </div>
    </form>
    <form
      class="search-input"
      action="/search"
      @submit="subSearch"
      v-if="mode == 'athena-header'"
    >
      <button type="submit" class="btn-search">
        <span class="iconfont icon-i-chaxun"></span>
      </button>
      <input
        class="secondary_title"
        type="text"
        name="q"
        v-model="search_string"
        ref="input"
        :placeholder="$t('home.search_our_store')"
      />
      <button type="submit" class="btn-search-tx">
        <span>{{ $t("venue.home.search") }}</span>
      </button>
    </form>
    <div v-if="mode == 'athena-header'||vogue_mode == 'popup'" class="overlay" @click="close"></div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: {
    mode: {},
  },
  data() {
    return {
      search_string: "",
      active: true,
    };
  },
  methods: {
    close(e) {
      if (e.target !== this.search_el) {
        this.$("body").css({ overflowY: "" });
        this.active = false;
      }
    },
    subSearch(){
      this.send_fb_event('Search', {search_string: this.search_string})
      if (window.ttq && window.send_ttp_event) {
        window.send_ttp_event('Search',{query:this.search_string})
      }
      //搜索时snapchat的 SEARCH 事件
      if(window.snaptr){
        window.snaptr('track', 'SEARCH',{'search_string':this.search_string})
      }
    }
    
  },
  mounted() {
    if (this.mode == "athena-header") {
      this.active = false;
      this.search_el = this.$(".site-header .header-left>.search>a")[0];
      this.$(".site-header .header-left>.search>a").on("click", (e) => {
        e.preventDefault();
        this.active = !this.active;
        this.$nextTick(() => {
          this.$refs.input.focus();
          this.$("body").css({ overflowY: "hidden" });
        });
      });
      document.body.addEventListener(
        "click",
        this.debounce(this.close, 100),
        false
      );
    }
    if (this.vogue_mode == "popup") {
      this.active = false;
      this.search_el = this.$(".site-header .search-box>.search>a")[0];
      this.$(".site-header .search-box>.search>a").on("click", (e) => {
        e.preventDefault();
        this.active = !this.active;
        this.$nextTick(() => {
          this.$refs.input.focus();
          this.$("body").css({ overflowY: "hidden" });
        });
      });
      document.body.addEventListener(
        "click",
        this.debounce(this.close, 100),
        false
      );
    }
  },
  computed: {
    ...mapState({
      vogue_mode: ({ options }) => options?.theme?.global?.search || '',
    }),
  },
};
</script>
<style scoped   lang='scss'>
.search-input {
  display: inline-block;
  margin: 0;
  padding: 0;
  position: relative;
  width: 100%;
  .form-group {
      position: relative;
      margin-bottom: 0px;
      width: 100%;
      max-width: 1200px;
      input {
        padding-right: 40px;
      }
      .form-control {
        width: 100%;
        padding: 10px 95px 10px 45px;
        font-style: normal;
        margin: 0;
        height: 40px;
        border: 1px solid #D2D2D2;;
        border-radius: 0;
        font-size: 14px;
        // background-color: rgba(66, 66, 66, 0.08);
        color: #858585;
        // transition: background-color 0.2s ease-out;
      }

      .form-control:hover,
      .form-control:focus {
        box-shadow: initial;
      }
      .nav-search-submit {
        position: absolute;
        top: 0px;
        bottom: 0;
        left: 0;
        width: 45px;
        margin: 0;
        border: 0 none;
        background: none;
        text-align: center;
        cursor: pointer;
        font-size: 18px;
        padding: 5px 6px;
        .icon-search:before {
          content: "\73";
        }
      }
      .nav-search-text {
        right: 0 !important;
        left: unset !important;
        width: 105px !important;
        text-transform: uppercase;
      }
    }
  .btn-search {
    position: absolute;
    line-height: 1;
    top: 50%;
    transform: translate(0, -50%);
    left: 10px;
    .iconfont.icon-i-chaxun {
      font-size: 20px;
      font-weight: 600;
    }
  }
  input {
    height: 52px;
    padding: 6px 10px 6px 38px;
    border: 1px solid #cccccc;
    border-radius: 4px;
    width: 100%;
    font-size: 18px;
    font-weight: 400;
    color: #222a40;
    &:focus {
      outline: none;
    }
  }
  .btn-search-tx {
    display: none;
  }
}
.athena-header-search {
  box-shadow: 0px -1px 0px 0px #eaeaea;
  text-align: center;
  padding: 14px 15px;
  position: relative;
  .overlay {
    content: " ";
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.4);
    z-index: 999999;
  }
  & > form {
    display: flex;
    justify-content: center;
    white-space: nowrap;
    .btn-search {
      display: none;
    }
    input {
      max-width: 1132px;
      padding: 19px 24px;
      border: none;
      background: #f3f3f5;
      border-radius: 0px;
    }
    .btn-search-tx {
      display: block;
      margin-left: 30px;
      font-size: 20px;
      font-family: Roboto;
      font-weight: 600;
      color: #222a40;
    }
  }
}
.vogue-header-search {
  // box-shadow: 0px -1px 0px 0px #eaeaea;
  border-top: 1px solid #eaeaea;
  text-align: center;
  padding: 15px 30px;
  position: relative;
  .overlay {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.4);
    z-index: 99;
  }
  & > form {
    display: flex;
    justify-content: center;
    white-space: nowrap;
    .btn-search {
      display: none;
    }
    input {
      // max-width: 1132px;
      padding: 19px 24px;
      border: none;
      background: #fff;
      border-radius: 0px;
    }
    .btn-search-tx {
      display: block;
      margin-left: 30px;
      font-size: 20px;
      font-family: Roboto;
      font-weight: 600;
      color: #222a40;
    }
  }
}
@media screen and(max-width: 768px) {
  .athena-header-search {
    padding: 10px 15px;
    & > form {
      input {
        height: 40px;
        padding: 13px;
      }
      .btn-search-tx {
        font-size: 14px;
      }
    }
  }
}
</style>
